import * as React from 'react';
import { useCallback } from 'react';
import cn from 'classnames';
import MediaQuery from 'react-responsive';
import { format, MOBILE_MIN_WIDTH } from '../../../../../../../utils';
import { DatepickerTab } from '../Datepicker';
import { useTheme } from '../../../../../../../theme';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../../../../../../context';
import { tryParseDate } from './utils';
import ManualInput from './ManualInput/ManualInput';
import { CdnIcon } from '@shared/ui';
const Value = ({ className, isOpen, open, close, setRouteType, segmentId, withDateBack, routeType, dateBack, dateTo, onClear, onDateSelect, setIsRouteTypeSetManually, onClickDatepickerTabReturn, onClickDatepickerTabOutbound, isReturnDateDisabled = false }) => {
    const { Datepicker: css } = useTheme('SearchForm');
    const { t } = useTranslation('SearchForm');
    const { mobileFormType, proMode, separatedDatepicker } = useConfig().SearchForm;
    const alternative = mobileFormType !== 'common';
    const onManualDateEnter = (value) => {
        const parseDate = tryParseDate(value);
        if (parseDate) {
            onDateSelect(parseDate, routeType === DatepickerTab.Return);
        }
    };
    const handleRouteTypeChange = useCallback((e, routeType) => {
        // WEBSKY-7796: если не выбрана дата "туда", не даем выбрать дату "обратно"
        if (routeType === DatepickerTab.Return && isReturnDateDisabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        if (isOpen) {
            e.preventDefault();
            e.stopPropagation();
            setRouteType(routeType);
            setIsRouteTypeSetManually(true);
        }
        if (routeType === DatepickerTab.Return && onClickDatepickerTabReturn) {
            onClickDatepickerTabReturn();
        }
        if (routeType === DatepickerTab.Outbound && onClickDatepickerTabOutbound) {
            onClickDatepickerTabOutbound();
        }
    }, [routeType, isOpen, dateTo, dateBack, isReturnDateDisabled]);
    const handleClear = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onClear();
        if (separatedDatepicker) {
            close();
        }
    };
    return (React.createElement("div", { className: cn(className, css.dates, `${css.dates}_${segmentId}`, {
            [css.oneDate]: !withDateBack,
            [css.dates_focused]: isOpen,
            [css.alternative]: alternative
        }), onClick: () => {
            isOpen ? close() : open();
        } },
        React.createElement(MediaQuery, { minWidth: +MOBILE_MIN_WIDTH + 1 },
            React.createElement("div", { className: cn(css.dates__to, {
                    [css.dates__to_focused]: isOpen && routeType === DatepickerTab.Outbound
                }) },
                React.createElement(ManualInput, { onEnter: onManualDateEnter, showInput: isOpen && proMode && routeType === DatepickerTab.Outbound, inputClassName: css.date__input },
                    React.createElement(CdnIcon, { className: css.dates__icon, icon: 'Action/Show Calendar' }),
                    dateTo && (React.createElement("div", { className: css.date__inputWrapper, onClick: e => {
                            handleRouteTypeChange(e, DatepickerTab.Outbound);
                        } },
                        format(dateTo, 'dd MMM'),
                        React.createElement("span", { className: css.dow }, dateBack || isOpen || separatedDatepicker
                            ? format(dateTo, 'eeeeee')
                            : format(dateTo, 'eeee')))),
                    !dateTo && (isOpen || separatedDatepicker) && (React.createElement("span", { onClick: e => handleRouteTypeChange(e, DatepickerTab.Outbound) }, t('Outbound'))),
                    !separatedDatepicker && !dateTo && !dateBack && !isOpen && (React.createElement("span", { className: css.placeholder }, t('Dates'))))),
            withDateBack && (isOpen || dateBack || separatedDatepicker) && (React.createElement("div", { className: cn(css.dates__back, {
                    [css.dates__back_focused]: isOpen && routeType === DatepickerTab.Return,
                    [css.dates__back_disabled]: isReturnDateDisabled
                }) },
                React.createElement(ManualInput, { onEnter: onManualDateEnter, showInput: isOpen && proMode && routeType === DatepickerTab.Return, inputClassName: cn(css.date__input, css.date__input_back) }, dateBack ? (React.createElement("div", { onClick: e => {
                        handleRouteTypeChange(e, DatepickerTab.Return);
                    } },
                    format(dateBack, 'dd MMM'),
                    React.createElement("span", { className: css.dow }, format(dateBack, 'eeeeee')))) : (React.createElement("span", { onClick: e => handleRouteTypeChange(e, DatepickerTab.Return) }, t('Return')))))),
            (dateTo || dateBack) && isOpen && (React.createElement("div", { className: css.returnDelete, onClick: handleClear },
                React.createElement(CdnIcon, { icon: 'Action/Close-Clear' })))),
        React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH },
            React.createElement("div", { className: cn(css.dates__to), onClick: e => handleRouteTypeChange(e, DatepickerTab.Outbound) },
                React.createElement("span", { className: css.dates__to_text },
                    dateTo && (React.createElement("span", { className: css.dates__to_text },
                        format(dateTo, 'dd MMM'),
                        React.createElement("span", { className: css.dow }, format(dateTo, 'eeeeee')))),
                    !separatedDatepicker && dateBack && (React.createElement("span", { className: css.dates__to_text },
                        ` — ${format(dateBack, 'dd MMM')}`,
                        React.createElement("span", { className: css.dow }, format(dateBack, 'eeeeee'))))),
                !separatedDatepicker && alternative && dateTo && (React.createElement("div", { className: css.alternative_dow },
                    React.createElement("span", null, format(dateTo, 'eeee')),
                    dateBack && React.createElement("span", null, ` — ${format(dateBack, 'eeee')}`))),
                !dateTo &&
                    (separatedDatepicker || isOpen ? (t('Outbound')) : (React.createElement(React.Fragment, null,
                        React.createElement(CdnIcon, { className: css.dates__icon, icon: 'Action/Show Calendar' }),
                        React.createElement("span", { className: css.placeholder }, t('Dates')))))),
            withDateBack && separatedDatepicker && (React.createElement("div", { className: cn(css.dates__back), onClick: e => handleRouteTypeChange(e, DatepickerTab.Return) },
                React.createElement("span", { className: css.dates__to_text }, dateBack && (React.createElement("span", { className: css.dates__to_text },
                    format(dateBack, 'dd MMM'),
                    React.createElement("span", { className: css.dow }, format(dateBack, 'eeeeee'))))),
                alternative && dateBack && (React.createElement("div", { className: css.alternative_dow },
                    React.createElement("span", null, format(dateBack, 'eeee')))),
                !dateBack && t('Return'))))));
};
export default Value;
